import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import { mapGetters } from 'vuex';
import { IEDate, uGetDateFormat, uGetTimeArray } from '@appbase/util';
import * as types from '@reserve/store/types'
import { openReserveCalendarItem, openReserveResourceTime } from '@reserve/popup-handler';
import modalHelper from '@appbase/util/modal-helper';

import OccurrenceSelect from '@reserve/components/OccurrenceSelect.vue';
import EventItem from '@reserve/components/MergeView/EventItem.vue';

const IsPastAlldayEvent = function(currentDate: Date, e: reserve.CalendarItem): boolean {
    if(e.isAllDayEvent) {
        let dateKey = uGetDateFormat('yyyy-MM-dd', IEDate(currentDate));
        let itemKey = uGetDateFormat('yyyy-MM-dd', IEDate(e.start));

        return dateKey !== itemKey;
    } else {
        return false;
    }        
}

@Component({
    components: {
        EventItem
    },

    computed: mapGetters({
        currentDate: types.CALENDAR_DATE_CURRENT,
        dailyEvents: types.CALENDAR_DAILY_EVENT_LIST
    })
})
export default class ResourceLine  extends Vue {
    @Prop({ type: Object }) resource!: reserve.ResourceItemBase;

    currentDate!: reserve.DateItem;
    dailyEvents!: reserve.ItemList<reserve.CalendarItem>;

    timeArray: reserve.TimelineItem[] = [];    
    timelineEvents: { [key:string]: reserve.CalendarItem[] } = {};

    @Watch('dailyEvents')
    onEventsChanged(newVal: reserve.ItemList<reserve.CalendarItem>) {
        this.mountEvents(newVal);
    }

    created() {
        this.timeArray = uGetTimeArray([
            this.$t('W_AM').toString(),
            this.$t('W_PM').toString()
        ]);                   
                
        this.mountEvents(this.dailyEvents);
    }

    mountEvents(events: reserve.ItemList<reserve.CalendarItem>) {          
        this.timelineEvents = {};      
        let uniqueEvents: reserve.CalendarItem[] = []

        events.forEach(e => { 
            if (!(uniqueEvents.findIndex(ue => ue.id === e.id) >= 0)) {
                uniqueEvents.push(e);
            }
        })

        let resourceEvents = uniqueEvents.filter(e =>             
            e.resourceUpn.toLowerCase() === this.resource.address.toLowerCase() &&
            !IsPastAlldayEvent(this.currentDate.date, e) &&
            !e.isCancelled);        

        this.timeArray.forEach(t => {
            let dateString = uGetDateFormat('yyyy-MM-dd', IEDate(this.currentDate.date));
            let timeString = t.value;
            let dateKey = `${dateString}T${timeString}`;            

            this.timelineEvents[t.value] = resourceEvents.filter(e => {
                if (dateString == uGetDateFormat('yyyy-MM-dd', IEDate(e.start))) {
                        return dateKey ===
                            `${uGetDateFormat('yyyy-MM-dd', IEDate(e.start))}T${uGetDateFormat('H:i:00', IEDate(e.start))}`;
                } else {
                    return dateKey === `${dateString}T00:00:00`;
                }
            });
        });                
    }
    
    onTimeDblClick(time: reserve.TimelineItem, idx: number) {        
        let curDateStr = uGetDateFormat('yyyy-MM-dd', IEDate(this.currentDate.date));
        let dblStartTime = `${curDateStr}T${time.value}`;
        let dblEndTime = `${curDateStr}T${this.timeArray[idx + 1].value}`;
        
        openReserveResourceTime(this.resource.comCode, IEDate(dblStartTime), IEDate(dblEndTime), this.resource.itemStore, this.resource.address);
    } 

    onEventDblClick(event: reserve.CalendarItem) {
        if (event.appointmentType === 'Occurrence') {
            modalHelper.show({ component: OccurrenceSelect, force: true, value: event });
        } else if (event.appointmentType === 'Exception') {
            openReserveCalendarItem(event, 'exception');
        } else {
            openReserveCalendarItem(event);
        }     
    }
}